import { LitElement, html, css } from 'lit'

export class ToggleSwitch extends LitElement {
  static styles = [
    css`
      :host {
        display: flex;
      }

      input[type='checkbox'].switch {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
      }

      input[type='checkbox'].switch:focus {
        outline: 0;
      }

      .switch {
        height: 36px;
        width: 64px;
        border-radius: 36px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: 1px solid var(--color-black);
        background: #fff;
        transition: all 0.2s ease;
      }

      .switch:after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background: #000;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
      }

      .switch:checked {
        background-color: var(--color-black);
      }

      .switch:checked:after {
        background-color: #fff;
        transform: translatex(28px);
      }
    `,
  ]

  static properties = {
    checked: { type: Boolean, reflect: true },
  }

  connectedCallback() {
    super.connectedCallback()
    this.checked = false
  }

  render() {
    return html`
      <input type="checkbox" class="switch" ?checked=${this.checked} @click=${this._toggle} @keydown=${this._onKeydown} />
    `
  }

  updated() {
    this.checked = this.checked == true ? this.checked : false

    const input = this.shadowRoot.querySelector('input[type="checkbox"]')
    input.checked = this.checked
  }

  _onKeydown(e) {
    if (e.keyCode === 13 || e.key === 'Enter') {
      this._toggle()
    }
  }

  _toggle() {
    const el = this
    this.checked = !this.checked

    var event = new Event('change', {
      view: window,
      bubbles: true,
      cancelable: true,
      composed: true,
    })
    el.dispatchEvent(event)
  }
}
customElements.define('toggle-switch', ToggleSwitch)
